/**
 *   Feature toggle to expose storefront addresses to be usable as shipping addresses.
 *   When enabled clients should obtain addresses using the new endpoint instead of relying on the User proto.
 * Product Area: RETAILER_STORE_MANAGEMENT
 */
export const EXPOSE_STOREFRONT_ADDRESS_AS_SHIPPING_ADDRESS_240820 = 'EXPOSE_STOREFRONT_ADDRESS_AS_SHIPPING_ADDRESS_240820';
